import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    meta: { noCache: true },
    component: () => import("@/view/index/index.vue")
  },
  {
    path: "/notice",
    name: "Notice",
    component: () => import("@/view/notice/notice.vue")
  },
  {
    path: "/schoolDetails",
    name: "SchoolDetails",
    component: () => import("@/view/school/schoolDetails.vue")
  },
  {
    path: "/zyDetails",
    name: "ZyDetails",
    component: () => import("@/view/details/zyDetails.vue")
  },
  {
    path: "/findMajor",
    name: "FindMajor",
    meta: { noCache: true },
    component: () => import("@/view/major/findMajor.vue")
  },
  {
    path: "/findSchool",
    name: "FindSchool",
    meta: { noCache: true },
    component: () => import("@/view/school/findSchool.vue")
  },
  {
    path: "/chooseSchool",
    name: "ChooseSchool",
    component: () => import("@/view/school/chooseSchool.vue")
  },
  {
    path: "/voluntaryFilling",
    name: "VoluntaryFilling",
    component: () => import("@/view/volunteer/voluntaryFilling.vue")
  },
  {
    path: "/schoolPk",
    name: "SchoolPk",
    component: () => import("@/view/school/schoolPk.vue")
  },
  {
    path: "/occupation",
    name: "Occupation",
    component: () => import("@/view/occupation/occupation.vue")
  },
  {
    path: "/report",
    name: "Report",
    component: () => import("@/view/occupation/report.vue")
  },
  {
    path: "/region",
    name: "region",
    component: () => import("@/view/index/region.vue")
  },
  {
    path: "/newsDetails/:id",
    name: "newsDetails",
    component: () => import("@/view/details/newsDetails.vue")
  },
  {
    path: "/majorDetails",
    name: "MajorDetails",
    component: () => import("@/view/major/majorDetails.vue")
  },
  {
    path: "/textDescription",
    name: "TextDescription",
    component: () => import("@/view/occupation/testDescription.vue")
  },
  {
    path: "/startTest",
    name: "StartTest",
    component: () => import("@/view/occupation/startTest.vue")
  },
  {
    path: "/testResult",
    name: "TestResult",
    component: () => import("@/view/occupation/testResult.vue")
  },
  {
    path: "/myReport",
    name: "MyReport",
    component: () => import("@/view/occupation/myReport.vue")
  },
  {
    path: "/questionNaire",
    name: "QuestionNaire",
    meta: { noCache: false, topNoShow: true },
    component: () => import("@/view/questionNaire/questionNaire.vue")
  },
  {
    path: "/successSubject",
    name: "SuccessSubject",
    meta: { noCache: false, topNoShow: true },
    component: () => import("@/view/questionNaire/SuccessSubject.vue")
  },
  {
    path: "/sturegistration",
    name: "Sturegistration",
    meta: { noCache: false, topNoShow: true },
    component: () => import("@/view/signUp/index.vue")
  },
  {
    path: "/signUpSearch",
    name: "signUpSearch",
    meta: { noCache: false, topNoShow: true },
    component: () => import("@/view/signUp/list.vue")
  }
];
const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  document.title = "山东中职网";
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js